
<template>
    <div>
        <text-input :value="data.name" label="Name" ref="name"></text-input>
        <long-text-input :value="data.description" label="Kurzbeschreibung"
                            ref="description"></long-text-input>
        <long-text-input :value="data.longDescription" label="Impressum"
                            ref="longDescription"></long-text-input>
        <entity-multiselect
                entity="tag"
                label="Tags"
                :value="tagIds"
                @input="changedTags"
                name="tags"></entity-multiselect>
        <div class="position-relative">
          <div class="form-group">
              <label for="input_available_from">Verfügbar ab</label>
              <date-picker v-model="availableFrom" :config="datePickerOptions" id="input_available_from"></date-picker>
          </div>
        </div>
        <div class="position-relative">
          <div class="form-group">
              <label for="input_available_from">Disclaimer Datum</label>
              <date-picker v-model="disclaimerDate" :config="datePickerOptions" id="input_disclaimer_date"></date-picker>
          </div>
        </div>
        <div class="form-group">
            <label for="#chapter-position">Synthese Position</label>
            <input type="number" class="form-control" v-model="position" /> 
        </div>
        <button class="btn btn-primary" @click="save">Save</button>
    </div>
</template>
<script>
export default {
  props: ['data'],
  data() {
    return {
      availableFrom: this.data.synthesis.availableFrom && this.data.synthesis.availableFrom.format('DD.MM.YYYY'),
      disclaimerDate: this.data.synthesis.disclaimerDate && this.data.synthesis.disclaimerDate.format('DD.MM.YYYY'),
      tagIds: this.data.synthesis.tagIds,
      position: this.data.synthesis.position,
      datePickerOptions: {
        useCurrent: false,
        format: 'DD.MM.YYYY'
      }
    }
  },
  methods: {
    changedTags(value) {
      this.tagIds = value;
    },
    saveSynthesis() {
      let form = new FormData();
      const form_prefix = 'edit_synthesis';
      for (let id of this.tagIds) {
        form.append(form_prefix + "[tags][]", id);
      }
      form.append(form_prefix + '[availableFrom]', this.availableFrom || '');
      form.append(form_prefix + '[disclaimerDate]', this.disclaimerDate || '');
      form.append(form_prefix + '[position]', this.position);
      form.append(form_prefix + '[submit]', null);
      return axios
        .post('/api/' + store.state.language + '/synthesis/' + this.data.synthesisId + "/edit", form);
    },
    save() {
      Promise.all([
        this.saveSynthesis(),
        this.$refs.name.save(),
        this.$refs.description.save(),
        this.$refs.longDescription.save(),
      ]).then(() => {
        this.$router.push({ name: "key-theme-list" });
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/admin/key_theme/General.vue